// ParticlesWithLightRays.tsx
import React from 'react';

import { InteractiveBackground } from './InteractiveBackground';
import { LightRays } from './LightRays';

const ENABLE_INTERACTIVE_BACKGROUND = false;

const ParticlesWithLightRays: React.FC = () => {
  return (
    <div className="bg-stack">
      {ENABLE_INTERACTIVE_BACKGROUND ? <InteractiveBackground /> : null}
      <LightRays
        className="bg-rays"
        raysOrigin="top-center"
        raysColor="#94E3FE"
        raysSpeed={1}
        lightSpread={0.1}
        rayLength={3}
        pulsating
        fadeDistance={1}
        saturation={1}
        followMouse
        mouseInfluence={0.1}
        noiseAmount={0}
        distortion={0}
      />
    </div>
  );
};

export { ParticlesWithLightRays };
